import React, { useState } from "react";
import styles from "./RegistrationSuccess.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useNavigate } from "react-router-dom";
const RegistrationSuccess = () => {
  const navigate = useNavigate();
  if (localStorage.getItem("form_details")) {
    localStorage.removeItem("form_details");
  }
  if (localStorage.getItem("verified_email")) {
    localStorage.removeItem("verified_email");
  }
  if (localStorage.getItem("unverified_email")) {
    localStorage.removeItem("unverified_email");
  }

  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.box_main}>
          <div className={styles.box_main_head}>My Ace</div>
          <div className={styles.box_main_head2}>会員登録完了</div>
        </div>
        <div className={styles.header2_main}>
          <div className={styles.header2_1}>Thank you for registering.</div>
          <div className={styles.header2_2}>Please enjoy My Ace.</div>
        </div>
        <button
          onClick={() => {
            navigate("/");
          }}
          className={styles.button1}
        >
          Top
        </button>
      </div>
      <Footer />
    </>
  );
};

export default RegistrationSuccess;
